import { Tab } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";

export const ViewTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  color: theme.palette.text.primary,
  height: "40px",
  minHeight: "40px",
  marginRight: "4px",
  marginLeft: "4px",
  lineHeight: "3.25",
  ":hover": {
    background: alpha(theme.palette.primary.main, 0.1),
    borderRadius: "6px",
  },
  "&.Mui-selected": {
    color: theme.palette.primary.contrastText,
    background: theme.palette.primary.main,
    borderRadius: "6px",
  },
}));
